var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"holder",staticClass:"parallax-wrapper",class:_vm.classObject},[_c('div',{ref:"parallax",staticClass:"parallax",class:{'not-wrapped' : !_vm.wrapped},style:({ transform: _vm.elTransform, top: _vm.elTop + 'px', height: _vm.elHeight + 'px' })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac26285","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parallax.vue
// module id = wBx2
// module chunks = 1